import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

import CardActivity from '../components/CardActivity.jsx';
import News from '../components/News.jsx';
import RecentlyUsed from '../components/RecentlyUsed.jsx';
import Timeline from '../components/Timeline.jsx';
// import UnusedActiveCards from '../components/UnusedActiveCards.jsx';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    height: '90vh',
  },
  timeline: {
    marginRight: theme.spacing(6),
    height: '100%',
  },
}));

const HomePage = () => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Hidden smDown implementation="css">
        <div className={classes.timeline}>
          <Timeline />
        </div>
      </Hidden>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <RecentlyUsed />
        </Grid>
        <Grid item xs={12} lg={4}>
          {/* <UnusedActiveCards /> */}
        </Grid>
        <Grid item xs={12} lg={12}>
          <Button
            onClick={() => {
              history.push('/photorecall');
            }}
          >
            Photo Recall
          </Button>
          <CardActivity />
        </Grid>
        <Grid item xs={12}>
          <News />
        </Grid>
      </Grid>
    </div>
  );
};

export default HomePage;
